import { IAffiliateDashboard } from "./types";

type BudgetHistoryMetadata = Pick<
  IAffiliateDashboard,
  "allowances_history_complete" | "ended_allowances_next_cursor"
>;

export function validBudgetHistoryMetadata(data: BudgetHistoryMetadata) {
  return (
    (data.allowances_history_complete === undefined ||
      typeof data.allowances_history_complete === "boolean") &&
    (data.ended_allowances_next_cursor === undefined ||
      typeof data.ended_allowances_next_cursor === "string")
  );
}

export function hasCompleteBudgetHistory(data: BudgetHistoryMetadata) {
  return (
    validBudgetHistoryMetadata(data) &&
    data.allowances_history_complete !== false &&
    !data.ended_allowances_next_cursor
  );
}
